<template>
    <div class="purchase-item"
        @click="clickPurchase()">
        <div class="purchase-wrapper">
            <div class="purchase-img">
                <div class="purchase-img-wrapper">
                    <img class="img-fluid" :src="purchase.fullImageUrl" />
                </div>
            </div>
            <div class="purchase-info">
                <div class="purchase-name">{{purchase.masterCampaignName ? purchase.masterCampaignName : purchase.name}}</div>
                <div v-if="purchase.info3" class="purchase-branch">{{lbl.history.brance}} {{purchase.info3}}</div>
                <div class="purchase-redeemdate">{{lbl.history.date}} {{getRedeemedDate()}}</div>
                <div class="purchase-redeemtime">{{lbl.history.time}} {{getRedeemedTime()}}</div>
                <!-- <div class="purchase-redeemdate">{{getRedeemedDate()}}</div>
                <div class="purchase-point">{{getPointMessage()}}</div> -->
                <div class="purchase-row"
                    v-if="type === 'purchase'">
                    <div class="purchase-icon"></div>
                    <div class="purchase-wrapper">
                        <div>{{lbl.history.status}}</div>
                        <div v-if="isActive" class="purchase-txt" v-html="purchaseMessage"></div>
                        <div v-else
                            :class="{'expire': isExpire}"
                            class="purchase-used" v-html="purchaseMessage"></div>
                    </div>

                </div>
                <div class="purchase-row"
                    v-if="type === 'draw'">
                    <div class="purchase-wrapper">
                        <div>{{lbl.history.status}}</div>
                        <div class="purchase-txt no-icon" v-html="purchaseMessage"></div>
                    </div>
                </div>
                <div class="purchase-row"
                    v-if="type === 'interface'">
                    <div class="purchase-wrapper">
                        <div>{{lbl.history.status}}</div>
                        <div class="purchase-txt no-icon" v-html="purchaseMessage"></div>
                    </div>
                </div>
                <div class="purchase-row"
                    v-if="isShowDelivery">
                    <div class="purchase-txt no-icon"
                        v-html="deliveryMessage"></div>
                </div>
                <div class="purchase-row"
                    v-if="isShipped">
                    <div class="purchase-txt no-icon">
                        {{purchase.parcelNo}}
                    </div>
                </div>
                <div class="purchase-row"
                    v-if="isShowPrivilegeMessage">
                    <div class="purchase-txt no-icon"
                        v-html="privilegeMessage"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Util from '@/helper/Utility.js';
import Moment from 'moment';
import Locale from '@/helper/locale/locale.js';

export default {
    name: 'PurchaseItem',
    components: '',
    props: {
        lbl: Object,
        index: Number,
        purchase: Object
    },
    data: function () {
        return {
            campaignType: Vue.CampaignType,
            deliveryMessage: '',
            isActive: false,
            isShipped: false,
            isShowAdsMessage: false,
            isShowDelivery: false,
            isShowPrivilegeMessage: true,
            isWinner: false,
            lblHistory: this.lbl.history,
            lblPurchase: this.lbl.purchase,
            privilegeMessage: this.purchase.privilegeMessage,
            purchaseMessage: '',
            type: 'purchase', //draw, interface, purchase.
            isExpire: false,
        };
    },
    created: function () {
        this.initialPurchase();
    },
    mounted: function () {
    },
    methods: {
        //event
        clickPurchase: function () {
            if (!this.isActive) return;
            this.$emit('clickPurchase', this.index);
        },
        //method
        initialPurchase: function () {
            if (this.purchase.privilegeMessageFormat
                && this.purchase.privilegeMessageFormat.toLowerCase() === 'html')
                this.isShowPrivilegeMessage = false;

            //purchase message.
            switch(this.purchase.type) {
                case this.campaignType.Draw:
                    this.isDraw = true;
                    this.type = 'draw';
                    this.purchaseMessage = this.lblPurchase.not_draw1 + (this.lblPurchase.not_draw2 ? ' ' + this.lblPurchase.not_draw2 : '');

                    if (this.purchase.hasWinner) {
                        this.isActive = true;
                        if (this.purchase.isWinner) {
                            this.isWinner = true;
                            this.purchaseMessage = this.lblPurchase.draw_winner1 + (this.lblPurchase.draw_winner2 ? ' ' + this.lblPurchase.draw_winner2 : '');

                            if (this.isShowAdsMessage && this.purchase.adsMessage)
                                this.purchaseMessage += "<br />" + this.purchase.adsMessage;
                        } else {
                            this.isWinner = false;
                            this.purchaseMessage = this.lblPurchase.draw_not_win1 + (this.lblPurchase.draw_not_win2 ? ' ' + this.lblPurchase.draw_not_win2 : '');
                        }
                    }

                    this.isShowPrivilegeMessage = false;
                    break;
                case this.campaignType.Buy:
                case this.campaignType.Free:
                case this.campaignType.Deal:
                    if (this.purchase.serial == "XXXXXXX") {
                        this.isExpire = true;
                        this.purchaseMessage = this.lblPurchase.code_expired;
                    } else {
                        if (this.purchase.isUsed) {
                            this.purchaseMessage = this.lblPurchase.Used;
                        } else {

                            this.isActive = true;
                            this.purchaseMessage = this.lblPurchase.show_code;
                        }
                    }
                    break;
                case this.campaignType.Interface:
                    this.type = 'interface';
                    if (this.purchase.expireIn &&
                        this.purchase.expireIn < 0) {
                        this.purchaseMessage = this.lblPurchase.code_expired;

                        this.isShowPrivilegeMessage = false;
                    } else {
                        if (this.purchase.pointType == "get")
                            this.purchaseMessage = this.lblPurchase.interface_get;
                        else
                            this.purchaseMessage = this.lblPurchase.interface_use;
                    }

                    break;
            }
            //delivery.
            if (this.purchase.delivered === true) {
                this.isShowDelivery = true;
                if (this.purchase.type === this.campaignType.Draw) {
                    if (!this.purchase.hasWinner) {
                        this.isShowDelivery = false;
                    } else {
                        if (!this.purchase.isWinner)
                            this.isShowDelivery = false;
                    }
                }

                if (this.purchase.isShipped) {
                    this.isShipped = true;
                    this.deliveryMessage = this.lblPurchase.shipped;
                } else {
                    this.isShipped = false;
                    this.deliveryMessage = this.lblPurchase.delivery;
                }
            }

            this.deliveryMessage = Util.newLineToBr(this.deliveryMessage);
            this.privilegeMessage = Util.newLineToBr(this.privilegeMessage);
            this.purchaseMessage = Util.newLineToBr(this.purchaseMessage);
        },
        //utility
        getPointMessage: function () {
            var pointType = this.purchase.pointType == 'get' ? this.lblHistory.get_point : this.lblHistory.use_point;
            var pointUnit = this.lblHistory.point + (this.purchase.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            return pointType + " " + this.purchase.pointPerUnit + " " + pointUnit;
        },
        getRedeemedDate: function () {
            var timestamp = this.purchase.redeemDate;
            var redeemedDate = Moment.unix(timestamp).utc();

            var year = Moment.unix(timestamp).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) {
                var thaiyear = redeemedDate.get('year') + 543;
                year = thaiyear.toString();
            }
            var strDate = '';
            var date = redeemedDate.format('DD');
            var month = redeemedDate.format('M');
            console.log(date, month);
            strDate = date + "/" + month + "/" + year;

            return strDate;
        },
        getRedeemedTime: function () {
            var timestamp = this.purchase.redeemDate;
            var strTime = Moment.unix(timestamp).utc().format('HH:mm');

            return strTime;
        },

    }
};
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';

.purchase-item {
    @extend %display-flex;
    width: 50%;
    flex: 0 0 50%;

    &:nth-child(2n - 1) {
        padding-right: 10px;
    }

    &:nth-child(2n) {
        padding-left: 10px;
    }

    @media (max-width: $max-width-mobile) {
        width: 100%;
        flex: 0 0 100%;

        &:nth-child(2n - 1) {
            padding-right: 0;
        }

        &:nth-child(2n) {
            padding-left: 0;
        }
    }

    .purchase-wrapper {
        @extend %display-flex;
        width: 100%;
        padding: 10px 15px;
        // border: 1px solid #666666;

        .purchase-img {
            width: 35%;
            flex: 0 0 35%;

            .purchase-img-wrapper {
                position: relative;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                }

                &:before {
                    position: relative;
                    content: "";
                    display: block;
                    padding-top: 100%;
                }
            }
        }

        .purchase-info {
            width: 65%;
            flex: 0 0 65%;
            padding-left: 10px;
            padding-bottom: 15px;
            background: url("../../../../../assets/icon/line-2@3x.png") no-repeat bottom center;
            background-size: 150%;

            .cancel-booking-btn {
                border: solid 1px#000;
                padding: 0px 5px;
                margin-top: 10px;
                font-size: 13px;
                border-radius: 0;
            }

            .purchase-name {
                color: #000000;
                font-size: 18px;
                font-weight: bold;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }
            .purchase-redeemdate {
                font-size: 15px;
                color: #000000;
            }
            .purchase-redeemtime {

                font-size: 15px;
                color: #000000;
                margin-bottom: 25px;
            }
            .purchase-branch {
                font-size: 15px;
                color: #000000;
                padding-top: 5px;
            }
            .purchase-row {

                .purchase-wrapper {
                    display: flex;
                    padding: 0;
                    align-items: center;
                }

                .purchase-txt {
                    color: #000000;
                    text-decoration: underline;
                    font-weight: bold;
                    margin-bottom: 1px;
                    padding-left: 10px;
                }
                .purchase-used {
                    color: #cccccc;
                    margin-bottom: 1px;
                    padding-left: 10px;
                }
                .expire {
                    color: red;
                    text-decoration: none;
                    font-weight: normal;
                }
                .cancel-booking {

                    font-weight: normal;
                    text-decoration: none;
                }
            }
        }
    }
}
</style>
